import { Pie } from '@ant-design/plots';
import PlotAutoFit from '../Layout/PlotAutoFit';
import { myPalette } from '../Layout/Palettes';

const PiChart2 = () => {
  const config = {
    data: {
      type: 'fetch',
      value: 'https://render.alipay.com/p/yuyan/180020010001215413/antd-charts/pie-doughnut.json',
    },
    angleField: 'value',
    colorField: 'name',
    legend: {
      color: {
        title: true,
        position: "right",
        orientation: "horizontal",
        rowPadding: 8,
        itemMarker: "circle",
        itemMarkerSize: 18,
        itemLabelFill: myPalette.labelCollor,
        itemLabelFontSize: 12,
        itemLabelTextAlign: "left",
        itemBackgroundFill: myPalette.backCollor,
        itemBackgroundRadius: 10,
        itemBackgroundStroke: "rgba(0, 0, 0, 0.35)",
        itemBackgroundLineWidth: 1,
      },
    },
    innerRadius: 0.6,
    labels: [
  {
    text: "name",
    style: {
      fontSize: 10,
      fontWeight: "bold",
      fill: myPalette.labelCollor,   // ✅ به جای color
    },
  },
  {
    text: (d: any, i: number, data: any[]) => (i < data.length - 3 ? d.value : ""),
    style: {
      fontSize: 9,
      dy: 12,
      fill: myPalette.labelCollor,   // ✅
    },
  },
],
    style: {
      stroke: 'transparent',
      inset: 1,
      radius: 10,
    },
    scale: {
      color: {
        palette: myPalette.palette,
        offset: (t: any) => t * 0.8 + 0.1,
      },
    },



  };
  return (

    <PlotAutoFit style={{ background: myPalette.backCollor }}>
      {({ width, height }) => (
        <Pie
          {...config}
          autoFit={false}
          width={width}
          height={height}
        />
      )}
    </PlotAutoFit>

  );
};
export default PiChart2;
